<template>
  <v-container>
    <v-card class="pa-3" v-if="!storeSchema">
      <v-skeleton-loader
        class="mx-auto"
        type="table-heading, table-thead, table-tbody, table-tfoot"
      ></v-skeleton-loader>
    </v-card>
    <StoresTable v-else :schema="storeSchema" :stores="stores"/>
  </v-container>
</template>
<script>
// import { mapGetters, mapActions, mapMutations } from 'vuex'
// import { db, fb } from '@/api/firebase.js'
import redaApp from '../api/redaApp'
import StoresTable from '@/components/StoresTable.vue'
import firebaseApi from '../api/firebaseApi'
import { mapGetters } from 'vuex'
// import AccountReceivable from '@/components/AccountReceivable.vue'

export default {
  name: 'Stores',
  components: {
    StoresTable
  },
  data: () => ({
    stores: [],
    listenerStores: null,
    storeSchema: null
  }),
  mounted: function () {
    this.reset()
    redaApp.getDescribe('stores').then((schema) => {
      this.storeSchema = schema
    }).catch((e) => {
      console.error(e)
    })
  },
  beforeDestroy: function () {
    this.listenerStores()
  },
  methods: {
    reset () {
      if (this.listenerStores) this.listenerStores()
      this.listenerStores = firebaseApi.db.collection('stores')
        .where('company', '==', this.getCompany.identification)
        .onSnapshot(({ docs }) => {
          this.stores = []
          for (let i = 0; i < docs.length; i++) {
            const doc = docs[i]
            this.stores.push({ ...doc.data(), uid: doc.id })
          }
        })
    }
  },
  computed: {
    ...mapGetters('company', [
      'getCompany'
    ])
    // ...mapGetters()
  },

  watch: {
  }
  /* created () {
  }, */
}
</script>
<style type="text/css">
</style>
